import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { List } from 'immutable';
import { AttachmentView } from '../../../attachments/attachment-view.model';
import { DocumentTypesEnum } from '../../../document-data/document-data.data';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';

@Component({
  selector: 'app-attachments-list',
  templateUrl: './attachments-list.component.html',
  styleUrls: ['./attachments-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentsListComponent implements OnInit {
  @Input() attachments: List<AttachmentView>;
  @Input() documentType: DocumentTypesEnum;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() trackingObject: ITrackingObject;

  @Output()
  onDeleteAttachmentItem: EventEmitter<AttachmentView> = new EventEmitter<AttachmentView>();
  @Output()
  onUpdateAttachmentItem: EventEmitter<AttachmentView> = new EventEmitter<AttachmentView>();
  @Output() onEditMode: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit() {}
}
